
      export default defineNuxtPlugin(() => {
        const runtime = useRuntimeConfig();

        let src = 'https://lf1-cdn-tos.bytegoofy.com/obj/iconpark/icons_29472_189.49f83eef8e68a7041a01e431f78fae88.js';

        if(false) {
          if(runtime.app.cdnURL){
            src = runtime.app.cdnURL + '/undefined';
          }else{
            src = '/undefined';
          }
        }

        useHead({
          script: [{
            src,
            defer: true
          }],
        });
      })
      